export default {
  capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
  get: (p, o) => p.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, o)
}

